import { FolderPickerListItem } from './FolderPickerListItem';
import { FolderPickerEmpty } from './FolderPickerEmpty';
import { NewFolderInline } from './NewFolderInline';
import type { BrowsableItem } from './types';

interface FolderPickerListProps {
  items: BrowsableItem[];
  selectedItem: BrowsableItem | undefined;
  focusedIndex: number;
  currentFolderId?: string;
  selectedItems?: { id: string; itemtype: string }[];
  useCase: 'move' | 'copy';
  searchQuery: string;
  isCreatingFolder: boolean;
  onSelect: (item: BrowsableItem) => void;
  onNavigate: (id: string) => void;
  onCreateFolder: (title: string) => Promise<void>;
  onCancelCreate: () => void;
}

export function FolderPickerList({
  items,
  selectedItem,
  focusedIndex,
  currentFolderId,
  selectedItems,
  useCase,
  searchQuery,
  isCreatingFolder,
  onSelect,
  onNavigate,
  onCreateFolder,
  onCancelCreate,
}: FolderPickerListProps) {
  return (
    <div role="listbox" className="space-y-0.5 p-2">
      {isCreatingFolder && (
        <NewFolderInline onSubmit={onCreateFolder} onCancel={onCancelCreate} />
      )}

      {items.length === 0 && !isCreatingFolder ? (
        <FolderPickerEmpty searchQuery={searchQuery} />
      ) : (
        items.map((item, index) => {
          const isUnavailable =
            useCase === 'move' &&
            selectedItems?.some((si) => si.itemtype !== 'resource' && si.id === item.id) === true;

          return (
            <FolderPickerListItem
              key={item.id}
              item={item}
              selected={selectedItem?.id === item.id}
              focused={focusedIndex === index}
              unavailable={isUnavailable}
              isCurrent={item.id === currentFolderId}
              onSelect={onSelect}
              onNavigate={onNavigate}
            />
          );
        })
      )}
    </div>
  );
}
